export default ['self-avatar-item'];
